module.exports = __webpack_public_path__ + "img/account.rate.weekly.d9da7f4f.png";